import ObjectCopyService from "external-services/object-copy-service/index";
import PhoneNumberService from 'external-services/phone-number-service/index';
import { cloneDeep } from "lodash-es";
import BookingUpdateService from "external-services/booking-update-service/index";

const NS = 'AddCustomerDialogCtrl'; // jshint ignore:line

export default function AddCustomerDialogCtrl(
  $scope, $timeout, $mdDialog, customer, booking, isOffline
) {
  "ngInject";

  const vm = this;

  vm.booking = booking;
  vm.displayErrors = false;

  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SUCCESS = 2;
  vm.ERROR = 3;
  vm.state = vm.ENTER;
  vm.isOffline = isOffline;

  if (!customer) {
    vm.customer = {
      customerType: 'inline', // @todo: use CustomerTypes.inline. Severity: low
      firstName: vm.booking.firstName,
      phone: vm.booking.phone,
      email: vm.booking.email
    };
  } else {
    vm.customer = customer;
  }

  vm.cancel = cancel;
  vm.save = save;

  function cancel() {
    $mdDialog.hide();
  }

  function save(isValid) {
    vm.displayErrors = !isValid || !vm.customerValid;
    if (vm.displayErrors) {
      return;
    }
    var tempCustomer = cloneDeep(vm.customer);
    tempCustomer = PhoneNumberService.resetPhoneNumberWithTypeValidation(tempCustomer); // Remove country prefix when national number contains special char and a~z A~Z

    vm.state = vm.LOADING;
    BookingUpdateService.updateFromAnywhere(vm.booking, ObjectCopyService.angularSafeCopy(vm.booking), tempCustomer, false).then(function () {
      vm.state = vm.SUCCESS;
      $timeout(function () {
        $mdDialog.hide();
      }, 300);
    }).catch(function (err) {
      console.error(err);
      vm.state = vm.ERROR;
    });
  }
}

